import { useMemo } from 'react';

import { getDashboardNodes } from '../components/Dashboard/dashboard.render.utils';
import authStore from '../store/AuthStore';

export const useLoadDashboardNodes = (): any => {
  return useMemo(getDashboardNodes, [authStore.authenticatedUser]);
};
